// extracted by mini-css-extract-plugin
export var actions = "_tr-4";
export var item = "_tr-1";
export var price = "_tr-3";
export var quantity = "_tr-2";
export var table = "_tr-0";